import { render, staticRenderFns } from "./Welcome-menu.vue?vue&type=template&id=938db704&scoped=true&"
import script from "./Welcome-menu.vue?vue&type=script&lang=js&"
export * from "./Welcome-menu.vue?vue&type=script&lang=js&"
import style0 from "./Welcome-menu.vue?vue&type=style&index=0&id=938db704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938db704",
  null
  
)

export default component.exports